<template>
  <div style="padding-top: 3em;">
    <img src="/images/pae-logo.png" style="max-width: 140px; margin-bottom: 2em;" />

    <h4 class="title">New/Replacement Wheelie Bin Application Form</h4>
    <p>Please complete this request if you require a new or replacement wheelie bin.</p>

    <br />

    <template v-if="message">
      <div class="notification is-primary">{{ message }}</div>
      <p>
        >
        <a href="/onlineform/bin-new">New/Replacement Bin Request</a>
        <br />>
        <a href="/onlineform/bin-new-caddy">New/Replacement Kitchen Caddy/Compostable Bag Request</a>
        <br />>
        <a target="_blank" href="https://cityofpae.cleanaway.com.au/">Bin Repair Request</a>
      </p>
    </template>

    <form autocomplete="off" method="POST" @submit.prevent="onSubmit" v-if="!message">
      <input type="hidden" name="_token" :value="csrf" />
      <input type="hidden" v-model="form" />

      <div style="padding: 1em 0px; color: #aaa;">
        <small>* Required Fields</small>
      </div>

      <div class="columns is-multiline">
        <div class="column is-8">
          <div class="field">
            <div class="box">
              <article class="media">
                <div class="media-content">
                  <div class="content">
                    <p>
                      <strong>Repair Damaged Bin</strong>
                      <br />Damage to lid or wheels only, please complete the
                      <a
                        target="_blank"
                        href="https://cityofpae.cleanaway.com.au/"
                      >Online Bin Repair Form</a>.
                    </p>
                    <p>
                      <strong>Request New Kitchen Caddy/Compostable Bags</strong>
                      <br />If you have run out of compostable bags for the kitchen caddy, or require a new kitchen caddy, please complete the
                      <a
                        target="_blank"
                        href="/onlineform/bin-new-caddy"
                      >New/Replacement Kitchend Caddy/Compostable Bag Request Form</a>.
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>

      <!-- 
            <div class="columns is-multiline is-hidden">
              <div class="column is-8">

                <div class="notification is-info">
                  <h4 class="title">Note</h4>
                  <div class="content">
                    <p>For your request to be accepted you are required to either provide:</p>
                    <ul>
                      <li>a photo from the front of your property showing the bins and property frontage or</li>
                      <li>a photo of your drivers licence.</li>
                    </ul>
                  </div>
                  <div class="file has-name is-fullwidth">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fa fa-upload"></i>
                        </span>
                        <span class="file-label">
                          Choose a file…
                        </span>
                      </span>
                      <span class="file-name">
                        Screen Shot 2017-07-29 at 15.54.25.png
                      </span>
                    </label>
                  </div>
                </div>

              </div>
            </div>
      -->

      <div class="columns is-multiline">
        <div class="column is-4">
          <div class="field">
            <label class="label">First Name *</label>
            <div class="control">
              <input
                autofocus
                type="text"
                placeholder="Please enter your first name"
                :class="{ 'input': true, 'is-danger': $v.firstname.$error }"
                @input="$v.firstname.$touch()"
                id="firstname"
                name="firstname"
                v-model="firstname"
              />
              <span v-if="$v.firstname.$error && !$v.firstname.required" class="help is-danger">
                First name is
                required
              </span>
              <span v-if="$v.firstname.$error && !$v.firstname.alpha" class="help is-danger">
                Invalid characters
                entered
              </span>
            </div>
          </div>
        </div>

        <div class="column is-4">
          <div class="field">
            <label class="label">Last Name *</label>
            <div class="control">
              <input
                type="text"
                placeholder="Please enter your last name"
                :class="{ 'input': true, 'is-danger': $v.lastname.$error }"
                @input="$v.lastname.$touch()"
                id="lastname"
                name="lastname"
                v-model="lastname"
              />
              <span v-if="$v.lastname.$error && !$v.lastname.required" class="help is-danger">
                Last name is
                required
              </span>
              <span v-if="$v.lastname.$error && !$v.lastname.alpha" class="help is-danger">
                Invalid characters
                entered
              </span>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">Email Address *</label>
            <div class="control">
              <input
                type="text"
                placeholder="Please enter your email"
                :class="{ 'input': true, 'is-danger': $v.emailaddress.$error }"
                id="emailaddress"
                name="emailaddress"
                v-model="emailaddress"
                @input="$v.emailaddress.$touch()"
              />
              <span
                v-if="$v.emailaddress.$error && !$v.emailaddress.required"
                class="help is-danger"
              >
                Email is
                required
              </span>
              <span v-if="$v.emailaddress.$error && !$v.emailaddress.email" class="help is-danger">
                Format is
                incorrect
              </span>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">Contact Number *</label>
            <div class="control">
              <input
                type="text"
                placeholder="Please enter your contact number (eg. 84051234)"
                :class="{ 'input': true }"
                @input="$v.contactnumber.$touch()"
                id="contactnumber"
                name="contactnumber"
                v-model="contactnumber"
              />
              <span
                v-if="$v.contactnumber.$error && !$v.contactnumber.required"
                class="help is-danger"
              >
                Contact number
                is required
              </span>
              <span
                v-if="$v.contactnumber.$error && !$v.contactnumber.numeric"
                class="help is-danger"
              >
                Only numbers
                allowed
              </span>
            </div>
          </div>
        </div>

        <!-- Enter Address Selector Here -->
        <div class="column is-8">
          <div class="field">
            <label class="label">
              Address
              <small class="has-text-weight-light">
                -location of bin(s)
                <strong>(Select address in dropdown list as you type)</strong>
              </small> *
            </label>
            <div class="control">
              <PropertyAddress
                fieldName="address"
                source="/api/address/search"
                placeholder="eg. 1/10 Main St Semaphore"
                v-on:address="saveStreetAddress"
                v-on:addressTyping="saveStreetAddressTyping"
                v-on:addressPropertyNo="savePropertyNo"
              ></PropertyAddress>
              <div
                v-if="addressPropertyNo==0 && addressTyping.length>0"
                style="background: #eee; padding: 1em;"
              >
                <small>
                  Please type address in full and then select correct address from the drop down list.
                  <br />eg. 1/10 Main St Semaphore SA 5091
                </small>
                <template v-if="$v.addressPropertyNo.$error || this.addressNotFound == true">
                  (
                  <input type="checkbox" id="addressNotFound" v-model="addressNotFound" />
                  <label for="addressNotFound">
                    <small>I cannot find my address in the dropdown list.</small>
                  </label> )
                </template>
              </div>
              <span v-if="$v.addressPropertyNo.$error" class="help is-danger">
                Valid address is required. (Please select
                from dropdown list as you type)
              </span>
            </div>
            <div class="notification is-danger" v-if="addressPropertyNo==''">
              Property must be in the
              <strong>City of Port Adelaide Enfield</strong> area
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">Brief Property Description to Assist Delivery *</label>

            <div class="control">
              <textarea
                class="textarea"
                v-model="propertydescription"
                @input="$v.propertydescription.$touch()"
                placeholder="e.g. red brick / cream render / brown tiles"
              ></textarea>
              <span
                v-if="$v.propertydescription.$error && !$v.propertydescription.required"
                class="help is-danger"
              >Property Description is required</span>
              <span
                v-if="$v.propertydescription.$error && !$v.propertydescription.AlphNumCharsValidator"
                class="help is-danger"
              >Invalid character(s) entered</span>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">I State that: *</label>
            <div class="control">
              <div class="control">
                <label class="radio">
                  <input
                    type="radio"
                    id="damaged"
                    value="Damaged"
                    name="binstate"
                    v-model="binstate"
                    checked
                  />
                  My bin(s) has been damaged beyond repair.
                </label>
                <br />
                <label class="radio">
                  <input type="radio" id="stolen" value="Stolen" name="binstate" v-model="binstate" />
                  My bin(s) has been stolen.
                </label>
                <br />
                <label class="radio">
                  <input
                    type="radio"
                    id="newhouse"
                    value="Newly Built Property"
                    name="binstate"
                    v-model="binstate"
                  />
                  I have moved into a newly built property.
                </label>
                <br />
                <label class="radio">
                  <input
                    type="radio"
                    id="nobins"
                    value="No Bins at Property"
                    name="binstate"
                    v-model="binstate"
                  />
                  There were no bin(s) at the property when I moved in.
                </label>
              </div>

              <span
                v-if="$v.binstate.$error && !$v.binstate.required"
                class="help is-danger"
              >Option is required</span>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">The following bin(s) are required: *</label>
            <div class="control">
              <div class="control">
                <label class="checkbox">
                  <input
                    type="checkbox"
                    id="generalwaste"
                    @click="binRemovalSync"
                    value="General Waste (blue)"
                    name="binrequired"
                    v-model="binrequired"
                    checked
                  />
                  General Waste Bin (140L - Blue lid).
                </label>
                <br />
                <label class="checkbox">
                  <input
                    type="checkbox"
                    id="recycling"
                    @click="binRemovalSync"
                    value="Recycling (yellow)"
                    name="binrequired"
                    v-model="binrequired"
                  />
                  Recycle Bin (240L - Yellow lid).
                </label>
                <br />
                <label class="checkbox">
                  <input
                    type="checkbox"
                    id="organics"
                    @click="binRemovalSync"
                    value="Organics (green)"
                    name="binrequired"
                    v-model="binrequired"
                  />
                  Green Organics Bin (240L - Green lid).
                </label>
              </div>

              <span v-if="$v.binrequired.$error && !$v.binrequired.required" class="help is-danger">
                Option is
                required
              </span>
            </div>
          </div>
        </div>

        <div
          class="column is-8"
          v-if="binstate==='Damaged' && ( binrequired.indexOf('General Waste (blue)') >= 0 || binrequired.indexOf('Recycling (yellow)') >= 0 || binrequired.indexOf('Organics (green)') >= 0 )"
        >
          <div class="field">
            <label class="label">I would like my damaged bin(s) removed:</label>
            <div class="control">
              <div class="control">
                <div v-if="binrequired.indexOf('General Waste (blue)') >= 0">
                  <label class="checkbox">
                    <input
                      type="checkbox"
                      id="generalwasteremove"
                      value="General Waste (blue)"
                      name="binremoval"
                      v-model="binremoval"
                    />
                    General Waste Bin (140L - Blue lid).
                  </label>
                  <br />
                </div>
                <div v-if="binrequired.indexOf('Recycling (yellow)') >= 0">
                  <label class="checkbox">
                    <input
                      type="checkbox"
                      id="recyclingremove"
                      value="Recycling (yellow)"
                      name="binremoval"
                      v-model="binremoval"
                    />
                    Recycle Bin (240L - Yellow lid).
                  </label>
                  <br />
                </div>
                <div v-if="binrequired.indexOf('Organics (green)') >= 0">
                  <label class="checkbox">
                    <input
                      type="checkbox"
                      id="organicsremove"
                      value="Organics (green)"
                      name="binremoval"
                      v-model="binremoval"
                    />
                    Green Organics Bin (240L - Green lid).
                  </label>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="field">
            <label class="label">Other Comments</label>

            <div class="control">
              <textarea
                class="textarea"
                v-model="comments"
                placeholder="Enter any additional comments you may have."
              ></textarea>
            </div>
          </div>
        </div>

        <div class="column is-8">
          <div class="notification is-warning">
            <div v-if="binremoval.length">
              <p>
                <strong>Requirements for Damaged Bin Removal</strong>
              </p>
              <ul>
                <li>
                  <div class="form-check">
                    <label class="form-check-label" for="binPlacement">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="binPlacement"
                        id="binPlacement"
                        value="Yes"
                        :checked="agreePlacement"
                        @click="agreePlacement = !agreePlacement"
                      />&nbsp;
                      I will place damaged bin(s) kerbside immediately after submitting this form.
                    </label>
                  </div>
                </li>
                <li>
                  <div class="form-check">
                    <label class="form-check-label" for="binEmpty">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="binEmpty"
                        id="binEmpty"
                        value="Yes"
                        :checked="agreeEmpty"
                        @click="agreeEmpty = !agreeEmpty"
                      />&nbsp;
                      I will ensure damaged bin(s) are empty with a plastic bag tied to handle to help with
                      identification.
                    </label>
                  </div>
                </li>
              </ul>
              <hr style="background-color: #333; margin: .5rem 0;" />
              <p>
                <small>
                  Failure to meet the requirements for damaged bin removal will result in a hard refuse booking
                  needing to be lodged for removal of the damaged bin, wait times will apply.
                </small>
              </p>
              <br />
            </div>
            <div class="form-check">
              <label class="form-check-label" for="agreement">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="agreement"
                  id="agreement"
                  value="Yes"
                  :checked="agree"
                  @click="agree = !agree"
                />&nbsp;
                <strong>I hereby declare that the information provided is true and correct.</strong>
              </label>
            </div>
          </div>
        </div>

        <div class="column is-8" v-if="enableGoogleCaptch">
          <div class="field">
            <vue-recaptcha
              ref="invisibleRecaptcha"
              @verify="onVerify"
              @expired="onExpired"
              size="invisible"
              :sitekey="googleCaptchaKey"
            ></vue-recaptcha>
          </div>
        </div>

        <div class="modal" v-bind:class="{'is-active' : loading}">
          <div class="modal-background"></div>
          <div class="modal-content has-text-centered">
            <h1 class="title is-3 has-text-light">Please wait...</h1>
            <button
              class="button is-info is-loading is-fullwidth is-large"
              style="font-size: 5em; background: transparent;"
            >Submitting</button>
          </div>
        </div>

        <div class="column is-8">
          <div class="field is-grouped">
            <div class="control">
              <button
                class="button is-link is-primary"
                :disabled="!agree || ( binremoval.length>0 && (!agreePlacement || !agreeEmpty) )"
              >Submit</button>
            </div>
            <div class="control">
              <button class="button is-text" @click.prevent="clear">Clear</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";

import PropertyAddress from "../../../../../../resources/assets/js/components/address/Typeahead-CouncilAddress.vue";

import {
  alpha,
  required,
  requiredIf,
  email,
  numeric,
  alphaNum,
  minValue,
  minLength
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import moment from "moment";

// Custom Validators
import { AlphNumCharsValidator } from "../../../../../../resources/assets/js/validators/alpha-num-chars-validator";

export default {
  components: {
    PropertyAddress,
    VueRecaptcha
  },

  props: {
    form: {}
  },

  data() {
    return {
      googleCaptchaKey: "6LcyrE0UAAAAAExxoj3NBm1vA-WMu88CIigyzkBU",
      enableGoogleCaptch: false,

      csrf: "",
      formTitle: this.form,
      message: "",
      submitted: false,
      loading: false,

      fileIDs: [],

      // FORM DATA
      code: "",
      firstname: "",
      lastname: "",
      address: "",
      addressTyping: "",
      addressPropertyNo: "",
      addressNotFound: false,
      propertydescription: "",
      contactnumber: "",
      emailaddress: "",
      binstate: "",
      binrequired: [],
      binremoval: [],
      comments: "",
      agreePlacement: false,
      agreeEmpty: false,
      agree: false
    };
  },

  validations: {
    firstname: { required, alpha },
    lastname: { required, alpha },
    emailaddress: { required, email },
    contactnumber: { required, numeric },
    addressPropertyNo: {
      required: requiredIf(function() {
        return this.addressNotFound == false;
      })
    },
    propertydescription: { required, AlphNumCharsValidator },
    binstate: { required },
    binrequired: { required },
    form: [
      "firstname",
      "lastname",
      "emailaddress",
      "contactnumber",
      "addressPropertyNo",
      "propertydescription",
      "binstate",
      "binrequired"
    ]
  },

  watch: {
    binstate: function(val) {
      if (this.binstate != "Damaged") {
        this.binremoval = [];
        this.agreePlacement = false;
        this.agreeEmpty = false;
      }
    }
  },

  computed: {
    fullName: function() {
      return this.firstname + " " + this.lastname;
    },
    precis: function() {
      return (
        "New Bin Request - " +
        (this.addressPropertyNo > 0 ? this.address : this.addressTyping)
      );
    },

    formData: function() {
      var fields = {};
      fields.firstName = this.firstname;
      fields.lastName = this.lastname;
      fields.emailAddress = this.emailaddress;
      fields.contactNumber = this.contactnumber;
      fields.comments = this.comments;
      fields.binState = this.binstate;
      fields.binRequired = this.binrequired;
      fields.binRemoval = this.binremoval;
      fields.address =
        this.addressPropertyNo > 0 ? this.address : this.addressTyping;

      fields.propertyNo =
        this.addressPropertyNo > 0 ? this.addressPropertyNo : 0;
      fields.propertydescription = this.propertydescription;

      fields.addressCustomer =
        this.addressPropertyNo > 0 ? this.address : this.addressTyping;

      fields.propertyNoCustomer =
        this.addressPropertyNo > 0 ? this.addressPropertyNo : 0;

      fields.precis = this.precis;
      fields.subject = "5.36.1.5";

      return JSON.stringify(fields);
    }
  },

  methods: {
    binRemovalSync: function(event) {
      if (!event.target.checked) {
        this.binremoval.splice(this.binremoval.indexOf(event.target.value), 1);
      }
    },

    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    saveStreetAddress(value) {
      this.address = value;
    },

    saveStreetAddressTyping(value) {
      this.addressTyping = value;
    },

    savePropertyNo(value) {
      this.addressPropertyNo = value;
    },

    displayAddressError(value) {
      alert(value);
    },

    onSubmit() {
      if (this.validate()) {
        if (this.enableGoogleCaptch) {
          this.$refs.invisibleRecaptcha.execute();
        } else {
          this.submitForm();
        }
      }
    },

    submitForm() {
      this.loading = true;
      axios
        .post("/onlineform/" + this.form, {
          _token: this.csrf,
          formTitle: this.formTitle,
          fullName: this.fullName,
          emailAddress: this.emailaddress,
          contactNumber: this.contactnumber,
          precis: this.precis,
          formData: this.formData,
          message: ""
        })
        .then(response => {
          // console.log(response.data.message);
          this.message = response.data.message;
          this.clear();
          //this.submitted = true
          setTimeout(() => (this.submitted = true), 5000);
          this.loading = false;
        });
    },

    onVerify: function(response) {
      if (response) {
        axios
          .post("/api/recaptchaSiteVerify", {
            value: response
          })
          .then(gresponse => {
            // console.log(gresponse);

            if (gresponse["data"] === "valid") {
              this.submitForm();
            } else {
              this.loading = false;
              this.message = "Failed verify google captcha!";
              console.log("Failed verify google captcha!");
            }
          })
          .catch(error => {
            console.log(error.response.data);
          });
      } else {
        alert("Failed captcha");
      }
    },
    onExpired: function() {
      console.log("Expired");
    },

    onSuccess(response) {},

    clear() {}
  },

  mounted() {
    this.csrf = window.laravel.csrfToken;
  }
};
</script>


// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/components/LayoutBinNew2.vue